// Hardcoded print-method payloads streamed to the customizer in discovery mode.
//
// These are sample/sandbox configurations that the backoffice forces onto the previewed product over
// postMessage (DiscoveryModeUpdate, category 'printing'). They mirror the raw print-type shape the
// customizer API returns, so the customizer can map and inject them like any real print method.
//
// For now only laser engraving is wired up; add more entries here as other discovery buttons are
// implemented, keyed by the DiscoveryModePanel item id.

export const WOOD_ENGRAVING_PRINT_METHOD = {
    printTypeID: 1000147,
    name: 'Wood Engraving',
    providerCode: '',
    dpi: null,
    printTypeDPI: 300,
    priceDeltaPerc: 0,
    priceDeltaValue: 0,
    price: 0,
    textBasePrice: 0,
    imageBasePrice: 0,
    pricingID: 0,
    patID: 2,
    disableTextColors: null,
    disableImageColors: null,
    disableSellerImages: null,
    disableUserImages: null,
    useImagesFixedSize: null,
    textColors: null,
    imageColors: null,
    canAddText: null,
    canChangeSvgColors: null,
    canUseImageFilters: null,
    uploadRestrictions: null,
    canIgnoreDPIWarning: null,
    useCustomFonts: null,
    canPreviewDesignsPDF: null,
    showDuplicateButton: null,
    showLayerButtons: null,
    showFlipButtons: null,
    showImageProvider: null,
    canUseTextArt: null,
    imageEditingToolSettingsToExclude: null,
    convertEpsToSvg: null,
    convertPdfToSvg: null,
    convertAiToSvg: null,
    outputTypeID: null,
    printTypeDefaultFontFamilyID: null,
    defaultFontFamilyID: null,
    printTypeRestrictionsID: 1000124,
    outputSettings: null,
    printTypeRestrictions: {
        partPrintTypeRestrictionID: 1000124,
        disableTextColors: false,
        allowGradientTextColors: false,
        allowImageUploadTextColors: false,
        allowImageGalleryTextColors: false,
        enableVectorize: false,
        showVectorizeModal: false,
        vectorizeOption: 0,
        createVectorizePreview: false,
        disableImageColors: false,
        disableSellerImages: false,
        disableUserImages: false,
        useImagesFixedSize: false,
        textColors: [],
        imageColors: [],
        canAddText: true,
        canChangeSvgColors: true,
        canUseImageFilters: true,
        uploadRestrictions: {
            isUserImageAllowed: true,
            isJpgAllowed: true,
            isPngAllowed: true,
            isSvgAllowed: true,
            isPdfAllowed: true,
            isPdfWithRasterAllowed: true,
            isEpsAllowed: true,
            isAiAllowed: true,
            isFacebookAllowed: true,
            isInstagramAllowed: true,
            resizeLargePdf: false
        },
        canIgnoreDPIWarning: true,
        canPreviewDesignsPDF: true,
        showDuplicateButton: true,
        showLayerButtons: true,
        showFlipButtons: true,
        showImageProvider: true,
        canUseTextArt: true,
        imageEditingToolSettingsToExclude: '[]',
        imageInsertScalingUpload: 0,
        imageInsertScalingCliparts: 0,
        useCustomFonts: null,
        convertEpsToSvg: true,
        convertPdfToSvg: true,
        convertAiToSvg: true,
        defaultFontFamilyID: null,
        fonts: [],
        curvedText: true,
        allowBold: true,
        allowItalic: true,
        uppercase: false,
        maxNrTextElements: null,
        maxNrImages: null,
        defaultColor: '#287fb9',
        allowLeftAlign: true,
        allowCenterAlign: true,
        allowJustifyAlign: true,
        allowRightAlign: true,
        textBox: true,
        allowLetterSpacing: true,
        minLetterSpacing: null,
        maxLetterSpacing: null,
        allowLineSpacing: true,
        minLineSpacing: null,
        maxLineSpacing: null,
        allowAdaptText: true,
        allowChangeFontSize: true,
        minFontSize: null,
        maxFontSize: null,
        fixedFontSize: null,
        allowTopVerticalAlignment: true,
        allowMiddleVerticalAlignment: true,
        allowBottomVerticalAlignment: true,
        allowShadows: false,
        canPrintShadows: true,
        disableImageRotateUpload: null,
        disableImageRotateCliparts: null,
        allowImageResizeUpload: null,
        minWidthImageResizeUpload: null,
        maxWidthImageResizeUpload: null,
        minHeightImageResizeUpload: null,
        maxHeightImageResizeUpload: null,
        allowImageResizeCliparts: null,
        minWidthImageResizeCliparts: null,
        maxWidthImageResizeCliparts: null,
        minHeightImageResizeCliparts: null,
        maxHeightImageResizeCliparts: null,
        defaultShadowColor: '#000000',
        shadowColors: [],
        defaultShadowBlur: null,
        defaultShadowDistance: null,
        defaultShadowAngle: null,
        minShadowBlur: null,
        maxShadowBlur: null,
        minShadowDistance: null,
        maxShadowDistance: null,
        minShadowAngle: null,
        maxShadowAngle: null,
        defaultFontSize: null,
        outputMirror: 0,
        embeddedColorType: 1,
        embeddedUseForRasterAlso: true,
        isLargeFileEnabled: true,
        fontSizeList: null,
        allowTextStroke: false,
        minTextStrokeWidth: 0,
        maxTextStrokeWidth: 4,
        canStretchImages: false,
        canStretchTexts: false,
        embeddedPdf: false
    },
    printTypeFonts: [],
    fonts: [],
    pantoneEnabled: false,
    previewDesignEffect: {
        type: 2,
        blendMode: 'hard-light',
        enhanceBlendMode: false,
        opacity: 0.9,
        textColor: null,
        imageEffectTypeName: 'None',
        imageEffectParameterValues: []
    },
    outputDesignEffect: null,
    maxColors: null,
    paletteID: null,
    paletteTypeID: null,
    paletteColors: [],
    splitColorFiles: false,
    layeredPdf: false,
    patternSettings: null,
    backgroundRemoverSettings: null
};

export const PIXELATION_PRINT_METHOD = {
    printTypeID: 1090915,
    name: 'Pixelation',
    providerCode: '',
    dpi: null,
    printTypeDPI: 300,
    priceDeltaPerc: 0,
    priceDeltaValue: 0,
    price: 0,
    textBasePrice: 0,
    imageBasePrice: 0,
    pricingID: 0,
    patID: 2,
    disableTextColors: null,
    disableImageColors: null,
    disableSellerImages: null,
    disableUserImages: null,
    useImagesFixedSize: null,
    textColors: null,
    imageColors: null,
    canAddText: null,
    canChangeSvgColors: null,
    canUseImageFilters: null,
    uploadRestrictions: null,
    canIgnoreDPIWarning: null,
    useCustomFonts: null,
    showImageProvider: null,
    canUseTextArt: null,
    imageEditingToolSettingsToExclude: null,
    convertEpsToSvg: null,
    convertPdfToSvg: null,
    convertAiToSvg: null,
    outputTypeID: null,
    printTypeDefaultFontFamilyID: null,
    defaultFontFamilyID: null,
    printTypeRestrictionsID: 1100878,
    outputSettings: null,
    printTypeRestrictions: {
        partPrintTypeRestrictionID: 1100878,
        disableTextColors: false,
        allowGradientTextColors: false,
        allowImageUploadTextColors: false,
        allowImageGalleryTextColors: false,
        enableVectorize: false,
        showVectorizeModal: true,
        vectorizeOption: 0,
        createVectorizePreview: false,
        disableImageColors: false,
        disableSellerImages: false,
        disableUserImages: false,
        useImagesFixedSize: false,
        textColors: [],
        imageColors: [],
        canAddText: true,
        canChangeSvgColors: true,
        canUseImageFilters: true,
        uploadRestrictions: {
            isUserImageAllowed: true,
            isJpgAllowed: true,
            isPngAllowed: true,
            isSvgAllowed: true,
            isPdfAllowed: true,
            isPdfWithRasterAllowed: true,
            isEpsAllowed: true,
            isAiAllowed: true,
            isFacebookAllowed: true,
            isInstagramAllowed: true,
            resizeLargePdf: false
        },
        canIgnoreDPIWarning: true,
        showImageProvider: true,
        canUseTextArt: true,
        imageEditingToolSettingsToExclude: '[]',
        imageInsertScalingUpload: 0,
        imageInsertScalingCliparts: 0,
        useCustomFonts: null,
        convertEpsToSvg: true,
        convertPdfToSvg: true,
        convertAiToSvg: true,
        defaultFontFamilyID: null,
        fonts: [],
        curvedText: true,
        allowBold: true,
        allowItalic: true,
        uppercase: false,
        maxNrTextElements: null,
        maxNrImages: null,
        defaultColor: '#287fb9',
        allowLeftAlign: true,
        allowCenterAlign: true,
        allowJustifyAlign: true,
        allowRightAlign: true,
        textBox: true,
        allowLetterSpacing: true,
        minLetterSpacing: null,
        maxLetterSpacing: null,
        allowLineSpacing: true,
        minLineSpacing: null,
        maxLineSpacing: null,
        allowAdaptText: true,
        allowChangeFontSize: true,
        minFontSize: null,
        maxFontSize: null,
        fixedFontSize: null,
        allowTopVerticalAlignment: true,
        allowMiddleVerticalAlignment: true,
        allowBottomVerticalAlignment: true,
        allowShadows: false,
        canPrintShadows: true,
        disableImageRotateUpload: false,
        disableImageRotateCliparts: false,
        allowImageResizeUpload: false,
        minWidthImageResizeUpload: null,
        maxWidthImageResizeUpload: null,
        minHeightImageResizeUpload: null,
        maxHeightImageResizeUpload: null,
        allowImageResizeCliparts: false,
        minWidthImageResizeCliparts: null,
        maxWidthImageResizeCliparts: null,
        minHeightImageResizeCliparts: null,
        maxHeightImageResizeCliparts: null,
        defaultShadowColor: '#000000',
        shadowColors: [],
        defaultShadowBlur: null,
        defaultShadowDistance: null,
        defaultShadowAngle: null,
        minShadowBlur: null,
        maxShadowBlur: null,
        minShadowDistance: null,
        maxShadowDistance: null,
        minShadowAngle: null,
        maxShadowAngle: null,
        defaultFontSize: null,
        outputMirror: 0,
        embeddedColorType: 2,
        embeddedUseForRasterAlso: true,
        isLargeFileEnabled: true,
        fontSizeList: null,
        allowTextStroke: false,
        minTextStrokeWidth: 0,
        maxTextStrokeWidth: 4,
        canStretchImages: false,
        canStretchTexts: false,
        embeddedPdf: false
    },
    printTypeFonts: [],
    fonts: [],
    pantoneEnabled: false,
    previewDesignEffect: {
        type: 3,
        blendMode: 'normal',
        enhanceBlendMode: false,
        opacity: 100,
        textColor: null,
        imageEffectTypeName: 'pixelation',
        imageEffectParameterValues: [{ name: 'pixelationLevel', value: '19' }]
    },
    outputDesignEffect: {
        type: 3,
        blendMode: 'normal',
        enhanceBlendMode: false,
        opacity: 100,
        textColor: null,
        imageEffectTypeName: 'pixelation',
        imageEffectParameterValues: [{ name: 'pixelationLevel', value: '19' }]
    },
    maxColors: null,
    paletteID: null,
    paletteTypeID: null,
    paletteColors: [],
    splitColorFiles: false,
    layeredPdf: false,
    patternSettings: null,
    backgroundRemoverSettings: null
};

export const ENGRAVING_PRINT_METHOD = {
    printTypeID: 4248,
    name: 'Laser Engraving',
    providerCode: '',
    dpi: null,
    printTypeDPI: 300,
    priceDeltaPerc: 0,
    priceDeltaValue: 0,
    price: 0,
    textBasePrice: 0,
    imageBasePrice: 0,
    pricingID: 0,
    patID: 2,
    disableTextColors: null,
    disableImageColors: null,
    disableSellerImages: null,
    disableUserImages: null,
    useImagesFixedSize: null,
    textColors: null,
    imageColors: null,
    canAddText: null,
    canChangeSvgColors: null,
    canUseImageFilters: null,
    uploadRestrictions: null,
    canIgnoreDPIWarning: null,
    useCustomFonts: null,
    canPreviewDesignsPDF: null,
    showDuplicateButton: null,
    showLayerButtons: null,
    showFlipButtons: null,
    showImageProvider: null,
    canUseTextArt: null,
    imageEditingToolSettingsToExclude: null,
    convertEpsToSvg: null,
    convertPdfToSvg: null,
    convertAiToSvg: null,
    outputTypeID: null,
    printTypeDefaultFontFamilyID: null,
    defaultFontFamilyID: null,
    printTypeRestrictionsID: 681,
    outputSettings: null,
    printTypeRestrictions: {
        partPrintTypeRestrictionID: 681,
        disableTextColors: false,
        allowGradientTextColors: false,
        allowImageUploadTextColors: false,
        allowImageGalleryTextColors: false,
        enableVectorize: false,
        showVectorizeModal: false,
        vectorizeOption: 0,
        createVectorizePreview: false,
        disableImageColors: false,
        disableSellerImages: false,
        disableUserImages: false,
        useImagesFixedSize: false,
        textColors: [],
        imageColors: [],
        canAddText: true,
        canChangeSvgColors: true,
        canUseImageFilters: true,
        uploadRestrictions: {
            isUserImageAllowed: true,
            isJpgAllowed: true,
            isPngAllowed: true,
            isSvgAllowed: true,
            isPdfAllowed: true,
            isPdfWithRasterAllowed: true,
            isEpsAllowed: true,
            isAiAllowed: true,
            isFacebookAllowed: true,
            isInstagramAllowed: true,
            resizeLargePdf: false
        },
        canIgnoreDPIWarning: true,
        canPreviewDesignsPDF: false,
        showDuplicateButton: true,
        showLayerButtons: true,
        showFlipButtons: true,
        showImageProvider: true,
        canUseTextArt: true,
        imageEditingToolSettingsToExclude: '[]',
        imageInsertScalingUpload: 0,
        imageInsertScalingCliparts: null,
        useCustomFonts: null,
        convertEpsToSvg: true,
        convertPdfToSvg: true,
        convertAiToSvg: true,
        defaultFontFamilyID: null,
        fonts: [],
        curvedText: true,
        allowBold: false,
        allowItalic: false,
        uppercase: false,
        maxNrTextElements: null,
        maxNrImages: null,
        defaultColor: '#287fb9',
        allowLeftAlign: true,
        allowCenterAlign: true,
        allowJustifyAlign: true,
        allowRightAlign: true,
        textBox: true,
        allowLetterSpacing: true,
        minLetterSpacing: -50,
        maxLetterSpacing: 50,
        allowLineSpacing: true,
        minLineSpacing: -50,
        maxLineSpacing: 50,
        allowAdaptText: true,
        allowChangeFontSize: true,
        minFontSize: 15,
        maxFontSize: 750,
        fixedFontSize: null,
        allowTopVerticalAlignment: true,
        allowMiddleVerticalAlignment: true,
        allowBottomVerticalAlignment: true,
        allowShadows: true,
        canPrintShadows: true,
        disableImageRotateUpload: null,
        disableImageRotateCliparts: null,
        allowImageResizeUpload: null,
        minImageResizeUpload: null,
        maxImageResizeUpload: null,
        allowImageResizeCliparts: null,
        minImageResizeCliparts: null,
        maxImageResizeCliparts: null,
        defaultShadowColor: '#000000',
        shadowColors: [],
        defaultShadowBlur: null,
        defaultShadowDistance: null,
        defaultShadowAngle: null,
        minShadowBlur: 1,
        maxShadowBlur: null,
        minShadowDistance: 1,
        maxShadowDistance: null,
        minShadowAngle: 1,
        maxShadowAngle: null,
        defaultFontSize: 45,
        outputMirror: 0,
        embeddedColorType: 1,
        embeddedUseForRasterAlso: true,
        isLargeFileEnabled: true,
        fontSizeList: null,
        allowTextStroke: true,
        minTextStrokeWidth: 1,
        maxTextStrokeWidth: 4,
        canStretchImages: true,
        canStretchTexts: true,
        embeddedPdf: false
    },
    printTypeFonts: [
        { printTypeID: 4248, fontFamilyID: 46, fontFamilyName: 'Cairo' },
        { printTypeID: 4248, fontFamilyID: 47, fontFamilyName: 'Fondamento' },
        { printTypeID: 4248, fontFamilyID: 51, fontFamilyName: 'Mada' },
        { printTypeID: 4248, fontFamilyID: 56, fontFamilyName: 'Adamina' },
        { printTypeID: 4248, fontFamilyID: 64, fontFamilyName: 'Condiment' },
        { printTypeID: 4248, fontFamilyID: 110038, fontFamilyName: 'Osake' }
    ],
    fonts: [],
    pantoneEnabled: false,
    previewDesignEffect: {
        type: 1,
        blendMode: 'normal',
        enhanceBlendMode: true,
        opacity: 0.7,
        textColor: null,
        imageEffectTypeName: 'greyscale',
        imageEffectParameterValues: [
            { name: 'Halftone', value: 'dithering' },
            { name: 'Overlay color', value: '#ff0000' }
        ]
    },
    outputDesignEffect: {
        type: 1,
        blendMode: 'normal',
        enhanceBlendMode: false,
        opacity: 100,
        textColor: null,
        imageEffectTypeName: 'None',
        imageEffectParameterValues: []
    },
    maxColors: null,
    paletteID: null,
    paletteTypeID: null,
    paletteColors: [],
    splitColorFiles: false,
    layeredPdf: false,
    patternSettings: {
        printTypeID: 4248,
        presets: [5, 1, 4, 6, 2, 3, 7, 8],
        isImageEnabled: true,
        isTextEnabled: true,
        allowSpacingChange: true,
        allowOffsetChange: true
    },
    backgroundRemoverSettings: null
};

export const SCREEN_PRINTING_PRINT_METHOD = {
    printTypeID: 4208,
    name: 'ScreenPrinting',
    providerCode: '',
    dpi: null,
    printTypeDPI: 300,
    priceDeltaPerc: 0,
    priceDeltaValue: 0,
    price: 0,
    textBasePrice: 0,
    imageBasePrice: 0,
    pricingID: 0,
    patID: 2,
    disableTextColors: null,
    disableImageColors: null,
    disableSellerImages: null,
    disableUserImages: null,
    useImagesFixedSize: null,
    textColors: null,
    imageColors: null,
    canAddText: null,
    canChangeSvgColors: null,
    canUseImageFilters: null,
    uploadRestrictions: null,
    canIgnoreDPIWarning: null,
    useCustomFonts: null,
    canPreviewDesignsPDF: null,
    showDuplicateButton: null,
    showLayerButtons: null,
    showFlipButtons: null,
    showImageProvider: null,
    canUseTextArt: null,
    imageEditingToolSettingsToExclude: null,
    convertEpsToSvg: null,
    convertPdfToSvg: null,
    convertAiToSvg: null,
    outputTypeID: null,
    printTypeDefaultFontFamilyID: null,
    defaultFontFamilyID: null,
    printTypeRestrictionsID: 652,
    outputSettings: null,
    printTypeRestrictions: {
        partPrintTypeRestrictionID: 652,
        disableTextColors: false,
        allowGradientTextColors: false,
        allowImageUploadTextColors: false,
        allowImageGalleryTextColors: false,
        enableVectorize: false,
        showVectorizeModal: false,
        vectorizeOption: 0,
        createVectorizePreview: false,
        disableImageColors: false,
        disableSellerImages: false,
        disableUserImages: false,
        useImagesFixedSize: false,
        textColors: [],
        imageColors: [],
        canAddText: true,
        canChangeSvgColors: true,
        canUseImageFilters: true,
        uploadRestrictions: {
            isUserImageAllowed: false,
            // Screenprinting is vector/spot-color art only — block all raster upload formats (JPG was the
            // last one still allowed; PNG / PDF-with-raster / Facebook / Instagram are already off). Vector
            // uploads (SVG / EPS / AI / vector PDF) stay enabled.
            isJpgAllowed: false,
            isPngAllowed: false,
            isSvgAllowed: true,
            isPdfAllowed: true,
            isPdfWithRasterAllowed: false,
            isEpsAllowed: true,
            isAiAllowed: true,
            isFacebookAllowed: false,
            isInstagramAllowed: false,
            resizeLargePdf: false
        },
        canIgnoreDPIWarning: true,
        canPreviewDesignsPDF: true,
        showDuplicateButton: true,
        showLayerButtons: true,
        showFlipButtons: true,
        showImageProvider: true,
        canUseTextArt: true,
        imageEditingToolSettingsToExclude: '[]',
        imageInsertScalingUpload: 0,
        imageInsertScalingCliparts: null,
        useCustomFonts: null,
        convertEpsToSvg: true,
        convertPdfToSvg: false,
        convertAiToSvg: true,
        defaultFontFamilyID: null,
        fonts: [],
        curvedText: true,
        allowBold: true,
        allowItalic: true,
        uppercase: false,
        defaultColor: '#279767',
        allowLeftAlign: true,
        allowCenterAlign: true,
        allowJustifyAlign: true,
        allowRightAlign: true,
        textBox: true,
        allowLetterSpacing: true,
        minLetterSpacing: null,
        maxLetterSpacing: null,
        allowLineSpacing: true,
        minLineSpacing: null,
        maxLineSpacing: null,
        allowAdaptText: true,
        allowChangeFontSize: true,
        minFontSize: null,
        maxFontSize: null,
        fixedFontSize: null,
        allowTopVerticalAlignment: true,
        allowMiddleVerticalAlignment: true,
        allowBottomVerticalAlignment: true,
        allowShadows: true,
        canPrintShadows: true,
        disableImageRotateUpload: false,
        disableImageRotateCliparts: true,
        allowImageResizeUpload: true,
        minImageResizeUpload: 30,
        maxImageResizeUpload: 70,
        allowImageResizeCliparts: true,
        minImageResizeCliparts: 20,
        maxImageResizeCliparts: 100,
        defaultShadowColor: '#279767',
        shadowColors: [],
        defaultShadowBlur: null,
        defaultShadowDistance: null,
        defaultShadowAngle: null,
        minShadowBlur: null,
        maxShadowBlur: null,
        minShadowDistance: null,
        maxShadowDistance: null,
        minShadowAngle: null,
        maxShadowAngle: null,
        defaultFontSize: null,
        outputMirror: 0,
        embeddedColorType: 1,
        embeddedUseForRasterAlso: true,
        isLargeFileEnabled: true,
        fontSizeList: null,
        allowTextStroke: true,
        minTextStrokeWidth: 0,
        maxTextStrokeWidth: 5,
        canStretchImages: false,
        canStretchTexts: false,
        embeddedPdf: false
    },
    printTypeFonts: [
        { printTypeID: 4208, fontFamilyID: 41, fontFamilyName: 'Leckerli One' },
        { printTypeID: 4208, fontFamilyID: 42, fontFamilyName: 'Amatic SC' },
        { printTypeID: 4208, fontFamilyID: 43, fontFamilyName: 'Kaushan Script' },
        { printTypeID: 4208, fontFamilyID: 44, fontFamilyName: 'Amiri' },
        { printTypeID: 4208, fontFamilyID: 45, fontFamilyName: 'Ramaraja' },
        { printTypeID: 4208, fontFamilyID: 46, fontFamilyName: 'Cairo' },
        { printTypeID: 4208, fontFamilyID: 47, fontFamilyName: 'Fondamento' },
        { printTypeID: 4208, fontFamilyID: 48, fontFamilyName: 'Gloria Hallelujah' },
        { printTypeID: 4208, fontFamilyID: 49, fontFamilyName: 'Indie Flower' },
        { printTypeID: 4208, fontFamilyID: 50, fontFamilyName: 'Arizonia' },
        { printTypeID: 4208, fontFamilyID: 51, fontFamilyName: 'Mada' },
        { printTypeID: 4208, fontFamilyID: 52, fontFamilyName: 'IM FELL English' },
        { printTypeID: 4208, fontFamilyID: 53, fontFamilyName: 'Berkshire Swash' },
        { printTypeID: 4208, fontFamilyID: 54, fontFamilyName: 'Permanent Marker' },
        { printTypeID: 4208, fontFamilyID: 55, fontFamilyName: 'Damion' },
        { printTypeID: 4208, fontFamilyID: 56, fontFamilyName: 'Adamina' },
        { printTypeID: 4208, fontFamilyID: 57, fontFamilyName: 'Rock Salt' },
        { printTypeID: 4208, fontFamilyID: 58, fontFamilyName: 'Pacifico' },
        { printTypeID: 4208, fontFamilyID: 59, fontFamilyName: 'Aladin' },
        { printTypeID: 4208, fontFamilyID: 60, fontFamilyName: 'Patrick Hand' },
        { printTypeID: 4208, fontFamilyID: 61, fontFamilyName: 'Cookie' },
        { printTypeID: 4208, fontFamilyID: 62, fontFamilyName: 'EB Garamond' },
        { printTypeID: 4208, fontFamilyID: 63, fontFamilyName: 'Merienda One' },
        { printTypeID: 4208, fontFamilyID: 64, fontFamilyName: 'Condiment' },
        { printTypeID: 4208, fontFamilyID: 291, fontFamilyName: 'Noto Sans' },
        { printTypeID: 4208, fontFamilyID: 2239, fontFamilyName: 'Alegreya Sans' },
        { printTypeID: 4208, fontFamilyID: 100009, fontFamilyName: 'Horrendous' },
        { printTypeID: 4208, fontFamilyID: 100016, fontFamilyName: 'Sour Gummy Expanded' },
        { printTypeID: 4208, fontFamilyID: 100023, fontFamilyName: 'cave' },
        { printTypeID: 4208, fontFamilyID: 110036, fontFamilyName: 'Dancing Script Medium_custom' },
        { printTypeID: 4208, fontFamilyID: 110037, fontFamilyName: 'Dancing Script_custom' }
    ],
    fonts: [],
    pantoneEnabled: false,
    previewDesignEffect: null,
    outputDesignEffect: null,
    maxColors: 5,
    // Keep null: discovery PMs are self-contained — colours come from paletteColors only. A real paletteID
    // would make the customizer fetch that account's palette and intersect it with paletteColors (the
    // customizer also strips it at intake; see useDiscoveryModeUpdater). Source example's id was 273.
    paletteID: null,
    paletteTypeID: null,
    paletteColors: ['#279767', '#922b7d', '#596148', '#7eb066', '#ef1372', '#202ed7', '#e8d119'],
    splitColorFiles: false,
    layeredPdf: false,
    patternSettings: null,
    backgroundRemoverSettings: null
};

export const MONOCHROME_PRINT_METHOD = {
    printTypeID: 1060705,
    name: 'Monochromie',
    providerCode: '',
    dpi: null,
    printTypeDPI: 300,
    priceDeltaPerc: 0,
    priceDeltaValue: 0,
    price: 0,
    textBasePrice: 0,
    imageBasePrice: 0,
    pricingID: 0,
    patID: 2,
    disableTextColors: null,
    disableImageColors: null,
    disableSellerImages: null,
    disableUserImages: null,
    useImagesFixedSize: null,
    textColors: null,
    imageColors: null,
    canAddText: null,
    canChangeSvgColors: null,
    canUseImageFilters: null,
    uploadRestrictions: null,
    canIgnoreDPIWarning: null,
    useCustomFonts: null,
    canPreviewDesignsPDF: null,
    showDuplicateButton: null,
    showLayerButtons: null,
    showFlipButtons: null,
    showImageProvider: null,
    canUseTextArt: null,
    imageEditingToolSettingsToExclude: null,
    convertEpsToSvg: null,
    convertPdfToSvg: null,
    convertAiToSvg: null,
    outputTypeID: null,
    printTypeDefaultFontFamilyID: null,
    defaultFontFamilyID: null,
    printTypeRestrictionsID: 1070674,
    outputSettings: null,
    printTypeRestrictions: {
        partPrintTypeRestrictionID: 1070674,
        disableTextColors: false,
        allowGradientTextColors: false,
        allowImageUploadTextColors: false,
        allowImageGalleryTextColors: false,
        enableVectorize: false,
        showVectorizeModal: true,
        vectorizeOption: 0,
        createVectorizePreview: false,
        disableImageColors: false,
        disableSellerImages: false,
        disableUserImages: false,
        useImagesFixedSize: false,
        textColors: [],
        imageColors: [],
        canAddText: false,
        canChangeSvgColors: true,
        canUseImageFilters: true,
        uploadRestrictions: {
            isUserImageAllowed: true,
            isJpgAllowed: true,
            isPngAllowed: true,
            isSvgAllowed: true,
            isPdfAllowed: true,
            isPdfWithRasterAllowed: true,
            isEpsAllowed: true,
            isAiAllowed: true,
            isFacebookAllowed: true,
            isInstagramAllowed: true,
            resizeLargePdf: false
        },
        canIgnoreDPIWarning: true,
        canPreviewDesignsPDF: true,
        showDuplicateButton: true,
        showLayerButtons: true,
        showFlipButtons: true,
        showImageProvider: true,
        canUseTextArt: true,
        imageEditingToolSettingsToExclude: '[]',
        imageInsertScalingUpload: 0,
        imageInsertScalingCliparts: null,
        useCustomFonts: null,
        convertEpsToSvg: true,
        convertPdfToSvg: true,
        convertAiToSvg: true,
        defaultFontFamilyID: null,
        fonts: [],
        curvedText: true,
        allowBold: true,
        allowItalic: true,
        uppercase: false,
        maxNrTextElements: null,
        maxNrImages: null,
        defaultColor: '#331478',
        allowLeftAlign: true,
        allowCenterAlign: true,
        allowJustifyAlign: true,
        allowRightAlign: true,
        textBox: true,
        allowLetterSpacing: true,
        minLetterSpacing: null,
        maxLetterSpacing: null,
        allowLineSpacing: true,
        minLineSpacing: null,
        maxLineSpacing: null,
        allowAdaptText: true,
        allowChangeFontSize: true,
        minFontSize: null,
        maxFontSize: null,
        fixedFontSize: null,
        allowTopVerticalAlignment: true,
        allowMiddleVerticalAlignment: true,
        allowBottomVerticalAlignment: true,
        allowShadows: false,
        canPrintShadows: true,
        disableImageRotateUpload: null,
        disableImageRotateCliparts: null,
        allowImageResizeUpload: null,
        minWidthImageResizeUpload: null,
        maxWidthImageResizeUpload: null,
        minHeightImageResizeUpload: null,
        maxHeightImageResizeUpload: null,
        allowImageResizeCliparts: null,
        minWidthImageResizeCliparts: null,
        maxWidthImageResizeCliparts: null,
        minHeightImageResizeCliparts: null,
        maxHeightImageResizeCliparts: null,
        defaultShadowColor: '#331478',
        shadowColors: [],
        defaultShadowBlur: null,
        defaultShadowDistance: null,
        defaultShadowAngle: null,
        minShadowBlur: null,
        maxShadowBlur: null,
        minShadowDistance: null,
        maxShadowDistance: null,
        minShadowAngle: null,
        maxShadowAngle: null,
        defaultFontSize: null,
        outputMirror: 0,
        embeddedColorType: 2,
        embeddedUseForRasterAlso: true,
        isLargeFileEnabled: true,
        fontSizeList: null,
        allowTextStroke: false,
        minTextStrokeWidth: 0,
        maxTextStrokeWidth: 4,
        canStretchImages: false,
        canStretchTexts: false,
        embeddedPdf: false
    },
    printTypeFonts: [],
    fonts: [],
    pantoneEnabled: false,
    previewDesignEffect: null,
    outputDesignEffect: null,
    maxColors: 1,
    // Keep null: discovery PMs are self-contained — colours come from paletteColors only (see the
    // screenprint note above / useDiscoveryModeUpdater). Source example's id was 1050311.
    paletteID: null,
    paletteTypeID: null,
    paletteColors: ['#331478', '#ff0000', '#00ff08', '#6b91a4', '#cf00bf', '#0097aa'],
    splitColorFiles: false,
    layeredPdf: false,
    patternSettings: null,
    backgroundRemoverSettings: null
};

// Sample Pantone palette streamed alongside the Pantone print method below. Pantone swatches are NOT
// part of the print-type shape: the customizer reads them from `customizerInfo.pantoneColors` (filled
// by the `customizerinfo` endpoint) and only shows them when that list is non-empty AND the active
// print type has `pantoneEnabled`. A sandbox account's list is usually empty, so we hardcode a sample
// set here and the customizer's discovery Pantone registrar lands it into `customizerInfo.pantoneColors`.
// Shape mirrors the endpoint's entries: { id, name, pantonecode, rgbhexcode }.
// Ordered by tone: chromatic colors around the hue wheel (red -> orange -> yellow -> green -> teal ->
// blue -> purple -> magenta), then neutrals grouped at the end from dark to light.
const PANTONE_SAMPLE_COLORS = [
    { id: 1, name: 'Wine', pantonecode: 'PANTONE 7421 C', rgbhexcode: '#651D32' },
    { id: 2, name: 'Rose', pantonecode: 'PANTONE 199 C', rgbhexcode: '#D50032' },
    { id: 3, name: 'Crimson', pantonecode: 'PANTONE 200 C', rgbhexcode: '#BA0C2F' },
    { id: 4, name: 'Bright Red', pantonecode: 'PANTONE 185 C', rgbhexcode: '#E4002B' },
    { id: 5, name: 'Cardinal Red', pantonecode: 'PANTONE 186 C', rgbhexcode: '#C8102E' },
    { id: 6, name: 'Burgundy', pantonecode: 'PANTONE 187 C', rgbhexcode: '#A6192E' },
    { id: 7, name: 'Scarlet', pantonecode: 'PANTONE 1795 C', rgbhexcode: '#D22630' },
    { id: 8, name: 'Coral', pantonecode: 'PANTONE 711 C', rgbhexcode: '#CB333B' },
    { id: 9, name: 'Salmon', pantonecode: 'PANTONE 178 C', rgbhexcode: '#FF585D' },
    { id: 10, name: 'Tangerine', pantonecode: 'PANTONE 1655 C', rgbhexcode: '#FC4C02' },
    { id: 11, name: 'Bright Orange', pantonecode: 'PANTONE 021 C', rgbhexcode: '#FE5000' },
    { id: 12, name: 'Pumpkin', pantonecode: 'PANTONE 165 C', rgbhexcode: '#FF671F' },
    { id: 13, name: 'Apricot', pantonecode: 'PANTONE 1505 C', rgbhexcode: '#FF6900' },
    { id: 14, name: 'Amber', pantonecode: 'PANTONE 7406 C', rgbhexcode: '#F2A900' },
    { id: 15, name: 'Mustard', pantonecode: 'PANTONE 7555 C', rgbhexcode: '#D29F13' },
    { id: 16, name: 'Honey', pantonecode: 'PANTONE 7548 C', rgbhexcode: '#FFC600' },
    { id: 17, name: 'Marigold', pantonecode: 'PANTONE 116 C', rgbhexcode: '#FFCD00' },
    { id: 18, name: 'Golden Yellow', pantonecode: 'PANTONE 109 C', rgbhexcode: '#FFD100' },
    { id: 19, name: 'Sunshine Yellow', pantonecode: 'PANTONE Yellow C', rgbhexcode: '#FEDD00' },
    { id: 20, name: 'Chartreuse', pantonecode: 'PANTONE 382 C', rgbhexcode: '#C4D600' },
    { id: 21, name: 'Lime', pantonecode: 'PANTONE 376 C', rgbhexcode: '#84BD00' },
    { id: 22, name: 'Vivid Green', pantonecode: 'PANTONE 361 C', rgbhexcode: '#43B02A' },
    { id: 23, name: 'Forest Green', pantonecode: 'PANTONE 7739 C', rgbhexcode: '#34B233' },
    { id: 24, name: 'Emerald', pantonecode: 'PANTONE 347 C', rgbhexcode: '#009639' },
    { id: 25, name: 'Kelly Green', pantonecode: 'PANTONE 354 C', rgbhexcode: '#00843D' },
    { id: 26, name: 'Mint', pantonecode: 'PANTONE 332 C', rgbhexcode: '#99E9D6' },
    { id: 27, name: 'Teal', pantonecode: 'PANTONE 320 C', rgbhexcode: '#009CA6' },
    { id: 28, name: 'Cyan', pantonecode: 'PANTONE 312 C', rgbhexcode: '#00A9CE' },
    { id: 29, name: 'Azure', pantonecode: 'PANTONE 7461 C', rgbhexcode: '#007DBA' },
    { id: 30, name: 'Steel Blue', pantonecode: 'PANTONE 5405 C', rgbhexcode: '#4F7385' },
    { id: 31, name: 'Process Blue', pantonecode: 'PANTONE 285 C', rgbhexcode: '#0072CE' },
    { id: 32, name: 'Sky Blue', pantonecode: 'PANTONE 300 C', rgbhexcode: '#005EB8' },
    { id: 33, name: 'Royal Blue', pantonecode: 'PANTONE 2935 C', rgbhexcode: '#0057B8' },
    { id: 34, name: 'Cornflower', pantonecode: 'PANTONE 660 C', rgbhexcode: '#2C6EBC' },
    { id: 35, name: 'Indigo', pantonecode: 'PANTONE 2746 C', rgbhexcode: '#171C8F' },
    { id: 36, name: 'Deep Purple', pantonecode: 'PANTONE 2607 C', rgbhexcode: '#4E008E' },
    { id: 37, name: 'Orchid', pantonecode: 'PANTONE 2592 C', rgbhexcode: '#9B26B6' },
    { id: 38, name: 'Magenta', pantonecode: 'PANTONE 254 C', rgbhexcode: '#87189D' },
    { id: 39, name: 'Royal Purple', pantonecode: 'PANTONE Purple C', rgbhexcode: '#BB29BB' },
    { id: 40, name: 'Plum', pantonecode: 'PANTONE 513 C', rgbhexcode: '#93328E' },
    { id: 41, name: 'Jet Black', pantonecode: 'PANTONE Black 6 C', rgbhexcode: '#101820' },
    { id: 42, name: 'Onyx', pantonecode: 'PANTONE 419 C', rgbhexcode: '#212721' },
    { id: 43, name: 'Charcoal', pantonecode: 'PANTONE 426 C', rgbhexcode: '#25282A' },
    { id: 44, name: 'Slate', pantonecode: 'PANTONE 432 C', rgbhexcode: '#333F48' },
    { id: 45, name: 'Graphite', pantonecode: 'PANTONE 7540 C', rgbhexcode: '#4B4F54' },
    { id: 46, name: 'Silver', pantonecode: 'PANTONE 877 C', rgbhexcode: '#8A8D8F' },
    { id: 47, name: 'Cool Gray', pantonecode: 'PANTONE Cool Gray 7 C', rgbhexcode: '#97999B' },
    { id: 48, name: 'Taupe', pantonecode: 'PANTONE Warm Gray 4 C', rgbhexcode: '#B6ADA5' },
    { id: 49, name: 'Light Gray', pantonecode: 'PANTONE 421 C', rgbhexcode: '#C1C6C8' },
    { id: 50, name: 'Mist', pantonecode: 'PANTONE 428 C', rgbhexcode: '#D0D3D4' }
];

export const PANTONE_PRINT_METHOD = {
    printTypeID: 4297,
    name: 'Pantone Colors',
    providerCode: '',
    dpi: null,
    printTypeDPI: 300,
    priceDeltaPerc: 0,
    priceDeltaValue: 0,
    price: 0,
    textBasePrice: 0,
    imageBasePrice: 0,
    pricingID: 0,
    patID: 2,
    disableTextColors: null,
    disableImageColors: null,
    disableSellerImages: null,
    disableUserImages: null,
    useImagesFixedSize: null,
    textColors: null,
    imageColors: null,
    canAddText: null,
    canChangeSvgColors: null,
    canUseImageFilters: null,
    uploadRestrictions: null,
    canIgnoreDPIWarning: null,
    useCustomFonts: null,
    canPreviewDesignsPDF: null,
    showDuplicateButton: null,
    showLayerButtons: null,
    showFlipButtons: null,
    showImageProvider: null,
    canUseTextArt: null,
    imageEditingToolSettingsToExclude: null,
    convertEpsToSvg: null,
    convertPdfToSvg: null,
    convertAiToSvg: null,
    outputTypeID: 1,
    printTypeDefaultFontFamilyID: null,
    defaultFontFamilyID: null,
    printTypeRestrictionsID: 713,
    outputSettings: null,
    printTypeRestrictions: {
        partPrintTypeRestrictionID: 713,
        disableTextColors: false,
        allowGradientTextColors: false,
        allowImageUploadTextColors: false,
        allowImageGalleryTextColors: false,
        enableVectorize: false,
        showVectorizeModal: false,
        vectorizeOption: 0,
        createVectorizePreview: false,
        disableImageColors: false,
        disableSellerImages: false,
        disableUserImages: false,
        useImagesFixedSize: false,
        textColors: [],
        imageColors: [],
        canAddText: true,
        canChangeSvgColors: true,
        canUseImageFilters: false,
        uploadRestrictions: {
            isUserImageAllowed: true,
            isJpgAllowed: true,
            isPngAllowed: true,
            isSvgAllowed: true,
            isPdfAllowed: true,
            isPdfWithRasterAllowed: true,
            isEpsAllowed: true,
            isAiAllowed: true,
            isFacebookAllowed: true,
            isInstagramAllowed: true,
            resizeLargePdf: false
        },
        canIgnoreDPIWarning: true,
        canPreviewDesignsPDF: true,
        showDuplicateButton: true,
        showLayerButtons: true,
        showFlipButtons: true,
        showImageProvider: true,
        canUseTextArt: true,
        imageEditingToolSettingsToExclude: '[]',
        imageInsertScalingUpload: 0,
        imageInsertScalingCliparts: null,
        useCustomFonts: null,
        convertEpsToSvg: true,
        convertPdfToSvg: true,
        convertAiToSvg: true,
        defaultFontFamilyID: null,
        fonts: [],
        curvedText: false,
        allowBold: true,
        allowItalic: true,
        uppercase: false,
        maxNrTextElements: null,
        maxNrImages: null,
        defaultColor: '#287fb9',
        allowLeftAlign: true,
        allowCenterAlign: true,
        allowJustifyAlign: true,
        allowRightAlign: true,
        textBox: true,
        allowLetterSpacing: true,
        minLetterSpacing: null,
        maxLetterSpacing: null,
        allowLineSpacing: true,
        minLineSpacing: null,
        maxLineSpacing: null,
        allowAdaptText: true,
        allowChangeFontSize: true,
        minFontSize: 100,
        maxFontSize: 400,
        fixedFontSize: null,
        allowTopVerticalAlignment: true,
        allowMiddleVerticalAlignment: true,
        allowBottomVerticalAlignment: true,
        allowShadows: true,
        canPrintShadows: true,
        disableImageRotateUpload: null,
        disableImageRotateCliparts: null,
        allowImageResizeUpload: null,
        minWidthImageResizeUpload: null,
        maxWidthImageResizeUpload: null,
        minHeightImageResizeUpload: null,
        maxHeightImageResizeUpload: null,
        allowImageResizeCliparts: null,
        minWidthImageResizeCliparts: null,
        maxWidthImageResizeCliparts: null,
        minHeightImageResizeCliparts: null,
        maxHeightImageResizeCliparts: null,
        defaultShadowColor: '#000000',
        shadowColors: [],
        defaultShadowBlur: null,
        defaultShadowDistance: null,
        defaultShadowAngle: null,
        minShadowBlur: null,
        maxShadowBlur: null,
        minShadowDistance: null,
        maxShadowDistance: null,
        minShadowAngle: null,
        maxShadowAngle: null,
        defaultFontSize: 240,
        outputMirror: 0,
        embeddedColorType: 1,
        embeddedUseForRasterAlso: true,
        isLargeFileEnabled: true,
        fontSizeList: null,
        allowTextStroke: false,
        minTextStrokeWidth: 0,
        maxTextStrokeWidth: 4,
        canStretchImages: false,
        canStretchTexts: false,
        embeddedPdf: false
    },
    printTypeFonts: [
        { printTypeID: 4297, fontFamilyID: 41, fontFamilyName: 'Leckerli One' },
        { printTypeID: 4297, fontFamilyID: 42, fontFamilyName: 'Amatic SC' },
        { printTypeID: 4297, fontFamilyID: 43, fontFamilyName: 'Kaushan Script' },
        { printTypeID: 4297, fontFamilyID: 44, fontFamilyName: 'Amiri' },
        { printTypeID: 4297, fontFamilyID: 45, fontFamilyName: 'Ramaraja' },
        { printTypeID: 4297, fontFamilyID: 46, fontFamilyName: 'Cairo' },
        { printTypeID: 4297, fontFamilyID: 47, fontFamilyName: 'Fondamento' },
        { printTypeID: 4297, fontFamilyID: 48, fontFamilyName: 'Gloria Hallelujah' },
        { printTypeID: 4297, fontFamilyID: 49, fontFamilyName: 'Indie Flower' },
        { printTypeID: 4297, fontFamilyID: 50, fontFamilyName: 'Arizonia' },
        { printTypeID: 4297, fontFamilyID: 51, fontFamilyName: 'Mada' },
        { printTypeID: 4297, fontFamilyID: 52, fontFamilyName: 'IM FELL English' },
        { printTypeID: 4297, fontFamilyID: 53, fontFamilyName: 'Berkshire Swash' },
        { printTypeID: 4297, fontFamilyID: 54, fontFamilyName: 'Permanent Marker' },
        { printTypeID: 4297, fontFamilyID: 55, fontFamilyName: 'Damion' },
        { printTypeID: 4297, fontFamilyID: 56, fontFamilyName: 'Adamina' },
        { printTypeID: 4297, fontFamilyID: 57, fontFamilyName: 'Rock Salt' },
        { printTypeID: 4297, fontFamilyID: 58, fontFamilyName: 'Pacifico' },
        { printTypeID: 4297, fontFamilyID: 59, fontFamilyName: 'Aladin' },
        { printTypeID: 4297, fontFamilyID: 60, fontFamilyName: 'Patrick Hand' },
        { printTypeID: 4297, fontFamilyID: 61, fontFamilyName: 'Cookie' },
        { printTypeID: 4297, fontFamilyID: 62, fontFamilyName: 'EB Garamond' },
        { printTypeID: 4297, fontFamilyID: 63, fontFamilyName: 'Merienda One' },
        { printTypeID: 4297, fontFamilyID: 64, fontFamilyName: 'Condiment' },
        { printTypeID: 4297, fontFamilyID: 291, fontFamilyName: 'Noto Sans' },
        { printTypeID: 4297, fontFamilyID: 2239, fontFamilyName: 'Alegreya Sans' },
        { printTypeID: 4297, fontFamilyID: 100009, fontFamilyName: 'Horrendous' },
        { printTypeID: 4297, fontFamilyID: 100016, fontFamilyName: 'Sour Gummy Expanded' },
        { printTypeID: 4297, fontFamilyID: 100023, fontFamilyName: 'cave' }
    ],
    fonts: [],
    pantoneEnabled: true,
    previewDesignEffect: null,
    outputDesignEffect: null,
    // Color-limited (NOT "no palette") so the customizer actually recolors images to the Pantone inks:
    // auto-recolor only runs for methods with maxColors > 0 AND a non-empty paletteColors (it remaps each
    // image colour to the nearest palette entry). The palette is the sample Pantone hexes; pantoneEnabled
    // + the injected customizerInfo.pantoneColors make the picker label them with Pantone codes/names.
    // Lower maxColors for a stronger reduction effect.
    maxColors: 50,
    paletteID: null,
    paletteTypeID: null,
    paletteColors: PANTONE_SAMPLE_COLORS.map((color) => color.rgbhexcode),
    splitColorFiles: false,
    layeredPdf: false,
    patternSettings: null,
    backgroundRemoverSettings: null,
    // Non-standard extra field (not part of the print-type API shape): the hardcoded Pantone palette
    // that the customizer's useDiscoveryPantoneRegistrar injects into customizerInfo.pantoneColors.
    pantoneColors: PANTONE_SAMPLE_COLORS
};

// A plain palette-limited method (like MONOCHROME) — NOT Pantone — so it needs no extra customizer hook:
// the discovery print-type registrar injects it into store.product and the fiber auto-recolors images to
// `paletteColors` (auto-recolor runs only for maxColors > 0 AND a non-empty paletteColors). `name` is set
// to 'CMYK Colors' so the design-elements dropdown shows that label. Process colours C/M/Y/K with
// maxColors: 4 read as CMYK; the source example was a 2-colour test palette (maxColors: 2, cyan/magenta/
// yellow) — restore those values here if you want the literal example instead.
export const CMYK_PRINT_METHOD = {
    printTypeID: 1030478,
    name: 'CMYK Colors',
    providerCode: '',
    dpi: null,
    printTypeDPI: 300,
    priceDeltaPerc: 0,
    priceDeltaValue: 0,
    price: 0,
    textBasePrice: 0,
    imageBasePrice: 0,
    pricingID: 0,
    patID: 2,
    disableTextColors: null,
    disableImageColors: null,
    disableSellerImages: null,
    disableUserImages: null,
    useImagesFixedSize: null,
    textColors: null,
    imageColors: null,
    canAddText: null,
    canChangeSvgColors: null,
    canUseImageFilters: null,
    uploadRestrictions: null,
    canIgnoreDPIWarning: null,
    useCustomFonts: null,
    canPreviewDesignsPDF: null,
    showDuplicateButton: null,
    showLayerButtons: null,
    showFlipButtons: null,
    showImageProvider: null,
    canUseTextArt: null,
    imageEditingToolSettingsToExclude: null,
    convertEpsToSvg: null,
    convertPdfToSvg: null,
    convertAiToSvg: null,
    outputTypeID: 1,
    printTypeDefaultFontFamilyID: null,
    defaultFontFamilyID: null,
    printTypeRestrictionsID: 1030454,
    outputSettings: null,
    printTypeRestrictions: {
        partPrintTypeRestrictionID: 1030454,
        disableTextColors: false,
        allowGradientTextColors: false,
        allowImageUploadTextColors: false,
        allowImageGalleryTextColors: false,
        enableVectorize: false,
        showVectorizeModal: false,
        vectorizeOption: 0,
        createVectorizePreview: false,
        disableImageColors: false,
        disableSellerImages: false,
        disableUserImages: false,
        useImagesFixedSize: false,
        textColors: [],
        imageColors: [],
        canAddText: true,
        canChangeSvgColors: true,
        canUseImageFilters: true,
        uploadRestrictions: {
            isUserImageAllowed: true,
            isJpgAllowed: true,
            isPngAllowed: true,
            isSvgAllowed: true,
            isPdfAllowed: true,
            isPdfWithRasterAllowed: true,
            isEpsAllowed: true,
            isAiAllowed: true,
            isFacebookAllowed: true,
            isInstagramAllowed: true,
            resizeLargePdf: false
        },
        canIgnoreDPIWarning: true,
        canPreviewDesignsPDF: true,
        showDuplicateButton: true,
        showLayerButtons: true,
        showFlipButtons: true,
        showImageProvider: true,
        canUseTextArt: true,
        imageEditingToolSettingsToExclude: '[]',
        imageInsertScalingUpload: 0,
        imageInsertScalingCliparts: null,
        useCustomFonts: null,
        convertEpsToSvg: true,
        convertPdfToSvg: true,
        convertAiToSvg: true,
        defaultFontFamilyID: null,
        fonts: [],
        curvedText: true,
        allowBold: true,
        allowItalic: true,
        uppercase: false,
        maxNrTextElements: null,
        maxNrImages: null,
        defaultColor: '#00ffff',
        allowLeftAlign: true,
        allowCenterAlign: true,
        allowJustifyAlign: true,
        allowRightAlign: true,
        textBox: true,
        allowLetterSpacing: true,
        minLetterSpacing: null,
        maxLetterSpacing: null,
        allowLineSpacing: true,
        minLineSpacing: null,
        maxLineSpacing: null,
        allowAdaptText: true,
        allowChangeFontSize: true,
        minFontSize: null,
        maxFontSize: null,
        fixedFontSize: null,
        allowTopVerticalAlignment: true,
        allowMiddleVerticalAlignment: true,
        allowBottomVerticalAlignment: true,
        allowShadows: true,
        canPrintShadows: true,
        disableImageRotateUpload: null,
        disableImageRotateCliparts: null,
        allowImageResizeUpload: null,
        minWidthImageResizeUpload: null,
        maxWidthImageResizeUpload: null,
        minHeightImageResizeUpload: null,
        maxHeightImageResizeUpload: null,
        allowImageResizeCliparts: null,
        minWidthImageResizeCliparts: null,
        maxWidthImageResizeCliparts: null,
        minHeightImageResizeCliparts: null,
        maxHeightImageResizeCliparts: null,
        defaultShadowColor: '#00ffff',
        shadowColors: [],
        defaultShadowBlur: null,
        defaultShadowDistance: null,
        defaultShadowAngle: null,
        minShadowBlur: null,
        maxShadowBlur: null,
        minShadowDistance: null,
        maxShadowDistance: null,
        minShadowAngle: null,
        maxShadowAngle: null,
        defaultFontSize: null,
        outputMirror: 0,
        embeddedColorType: 1,
        embeddedUseForRasterAlso: true,
        isLargeFileEnabled: true,
        fontSizeList: null,
        allowTextStroke: true,
        minTextStrokeWidth: 0,
        maxTextStrokeWidth: 10,
        canStretchImages: false,
        canStretchTexts: false,
        embeddedPdf: false
    },
    printTypeFonts: [],
    fonts: [],
    pantoneEnabled: false,
    previewDesignEffect: null,
    outputDesignEffect: null,
    maxColors: 4,
    // Intentionally null: with a paletteID set, the customizer's "new palette" picker shows the fetched
    // palette (by id) INTERSECTED with paletteColors, so any paletteColors entry NOT in that source-account
    // palette (e.g. the black #000000 we add) is dropped from the picker. Null → the picker uses
    // paletteColors directly (all 4 incl. black). The source example's id was 1030253 (cyan/magenta/yellow).
    paletteID: null,
    paletteTypeID: null,
    paletteColors: ['#00ffff', '#ff00ff', '#ffff00', '#000000'],
    splitColorFiles: false,
    layeredPdf: false,
    patternSettings: null,
    backgroundRemoverSettings: null
};

// DTG (Direct-to-Garment): full-color inkjet printing straight onto fabric. Its strength is photographic,
// gradient-rich artwork, so it's the most PERMISSIVE method — no colour limit and no palette (maxColors
// null, paletteColors []), no special effect, every upload format incl. raster (JPG/PNG/social), with
// filters / gradient text / shadows enabled. Self-contained: no paletteID, so no account-palette coupling.
// printTypeID is synthetic (there was no source export to copy — swap it if you wire a real one).
export const DTG_PRINT_METHOD = {
    printTypeID: 1090916,
    name: 'DTG Printing',
    providerCode: '',
    dpi: null,
    printTypeDPI: 300,
    priceDeltaPerc: 0,
    priceDeltaValue: 0,
    price: 0,
    textBasePrice: 0,
    imageBasePrice: 0,
    pricingID: 0,
    patID: 2,
    disableTextColors: null,
    disableImageColors: null,
    disableSellerImages: null,
    disableUserImages: null,
    useImagesFixedSize: null,
    textColors: null,
    imageColors: null,
    canAddText: null,
    canChangeSvgColors: null,
    canUseImageFilters: null,
    uploadRestrictions: null,
    canIgnoreDPIWarning: null,
    useCustomFonts: null,
    canPreviewDesignsPDF: null,
    showDuplicateButton: null,
    showLayerButtons: null,
    showFlipButtons: null,
    showImageProvider: null,
    canUseTextArt: null,
    imageEditingToolSettingsToExclude: null,
    convertEpsToSvg: null,
    convertPdfToSvg: null,
    convertAiToSvg: null,
    outputTypeID: null,
    printTypeDefaultFontFamilyID: null,
    defaultFontFamilyID: null,
    printTypeRestrictionsID: 1100879,
    outputSettings: null,
    printTypeRestrictions: {
        partPrintTypeRestrictionID: 1100879,
        disableTextColors: false,
        allowGradientTextColors: true,
        allowImageUploadTextColors: false,
        allowImageGalleryTextColors: false,
        enableVectorize: false,
        showVectorizeModal: false,
        vectorizeOption: 0,
        createVectorizePreview: false,
        disableImageColors: false,
        disableSellerImages: false,
        disableUserImages: false,
        useImagesFixedSize: false,
        textColors: [],
        imageColors: [],
        canAddText: true,
        canChangeSvgColors: true,
        canUseImageFilters: true,
        uploadRestrictions: {
            isUserImageAllowed: true,
            isJpgAllowed: true,
            isPngAllowed: true,
            isSvgAllowed: true,
            isPdfAllowed: true,
            isPdfWithRasterAllowed: true,
            isEpsAllowed: true,
            isAiAllowed: true,
            isFacebookAllowed: true,
            isInstagramAllowed: true,
            resizeLargePdf: false
        },
        canIgnoreDPIWarning: true,
        canPreviewDesignsPDF: true,
        showDuplicateButton: true,
        showLayerButtons: true,
        showFlipButtons: true,
        showImageProvider: true,
        canUseTextArt: true,
        imageEditingToolSettingsToExclude: '[]',
        imageInsertScalingUpload: 0,
        imageInsertScalingCliparts: 0,
        useCustomFonts: null,
        convertEpsToSvg: true,
        convertPdfToSvg: true,
        convertAiToSvg: true,
        defaultFontFamilyID: null,
        fonts: [],
        curvedText: true,
        allowBold: true,
        allowItalic: true,
        uppercase: false,
        maxNrTextElements: null,
        maxNrImages: null,
        defaultColor: '#000000',
        allowLeftAlign: true,
        allowCenterAlign: true,
        allowJustifyAlign: true,
        allowRightAlign: true,
        textBox: true,
        allowLetterSpacing: true,
        minLetterSpacing: null,
        maxLetterSpacing: null,
        allowLineSpacing: true,
        minLineSpacing: null,
        maxLineSpacing: null,
        allowAdaptText: true,
        allowChangeFontSize: true,
        minFontSize: null,
        maxFontSize: null,
        fixedFontSize: null,
        allowTopVerticalAlignment: true,
        allowMiddleVerticalAlignment: true,
        allowBottomVerticalAlignment: true,
        allowShadows: true,
        canPrintShadows: true,
        disableImageRotateUpload: false,
        disableImageRotateCliparts: false,
        allowImageResizeUpload: null,
        minWidthImageResizeUpload: null,
        maxWidthImageResizeUpload: null,
        minHeightImageResizeUpload: null,
        maxHeightImageResizeUpload: null,
        allowImageResizeCliparts: null,
        minWidthImageResizeCliparts: null,
        maxWidthImageResizeCliparts: null,
        minHeightImageResizeCliparts: null,
        maxHeightImageResizeCliparts: null,
        defaultShadowColor: '#000000',
        shadowColors: [],
        defaultShadowBlur: null,
        defaultShadowDistance: null,
        defaultShadowAngle: null,
        minShadowBlur: null,
        maxShadowBlur: null,
        minShadowDistance: null,
        maxShadowDistance: null,
        minShadowAngle: null,
        maxShadowAngle: null,
        defaultFontSize: null,
        outputMirror: 0,
        embeddedColorType: 1,
        embeddedUseForRasterAlso: true,
        isLargeFileEnabled: true,
        fontSizeList: null,
        allowTextStroke: true,
        minTextStrokeWidth: 0,
        maxTextStrokeWidth: 4,
        canStretchImages: true,
        canStretchTexts: true,
        embeddedPdf: false
    },
    printTypeFonts: [],
    fonts: [],
    pantoneEnabled: false,
    previewDesignEffect: null,
    outputDesignEffect: null,
    maxColors: null,
    paletteID: null,
    paletteTypeID: null,
    paletteColors: [],
    splitColorFiles: false,
    layeredPdf: false,
    patternSettings: null,
    backgroundRemoverSettings: null
};

// UV printing: UV-cured inkjet on RIGID substrates (wood, metal, acrylic, glass, plastic, promo items).
// Full-color and photo-capable like DTG, so the customizer editing config mirrors it — no colour limit, no
// palette, no special effect, every upload format incl. raster, with filters / gradient text / shadows. Its
// real-world distinctions (white-ink underbase, gloss/varnish layers, rigid media) are PRODUCTION-side, not
// customizer editing restrictions, so they aren't encoded here: layeredPdf is a no-op the PM page forces to
// false, and the white→spot-colour swap is an account-scoped RGB-conversion list (kept out to stay
// self-contained). Self-contained: no paletteID. printTypeID is synthetic (no source export).
export const UV_PRINT_METHOD = {
    printTypeID: 1090917,
    name: 'UV Printing',
    providerCode: '',
    dpi: null,
    printTypeDPI: 300,
    priceDeltaPerc: 0,
    priceDeltaValue: 0,
    price: 0,
    textBasePrice: 0,
    imageBasePrice: 0,
    pricingID: 0,
    patID: 2,
    disableTextColors: null,
    disableImageColors: null,
    disableSellerImages: null,
    disableUserImages: null,
    useImagesFixedSize: null,
    textColors: null,
    imageColors: null,
    canAddText: null,
    canChangeSvgColors: null,
    canUseImageFilters: null,
    uploadRestrictions: null,
    canIgnoreDPIWarning: null,
    useCustomFonts: null,
    canPreviewDesignsPDF: null,
    showDuplicateButton: null,
    showLayerButtons: null,
    showFlipButtons: null,
    showImageProvider: null,
    canUseTextArt: null,
    imageEditingToolSettingsToExclude: null,
    convertEpsToSvg: null,
    convertPdfToSvg: null,
    convertAiToSvg: null,
    outputTypeID: null,
    printTypeDefaultFontFamilyID: null,
    defaultFontFamilyID: null,
    printTypeRestrictionsID: 1100880,
    outputSettings: null,
    printTypeRestrictions: {
        partPrintTypeRestrictionID: 1100880,
        disableTextColors: false,
        allowGradientTextColors: true,
        allowImageUploadTextColors: false,
        allowImageGalleryTextColors: false,
        enableVectorize: false,
        showVectorizeModal: false,
        vectorizeOption: 0,
        createVectorizePreview: false,
        disableImageColors: false,
        disableSellerImages: false,
        disableUserImages: false,
        useImagesFixedSize: false,
        textColors: [],
        imageColors: [],
        canAddText: true,
        canChangeSvgColors: true,
        canUseImageFilters: true,
        uploadRestrictions: {
            isUserImageAllowed: true,
            isJpgAllowed: true,
            isPngAllowed: true,
            isSvgAllowed: true,
            isPdfAllowed: true,
            isPdfWithRasterAllowed: true,
            isEpsAllowed: true,
            isAiAllowed: true,
            isFacebookAllowed: true,
            isInstagramAllowed: true,
            resizeLargePdf: false
        },
        canIgnoreDPIWarning: true,
        canPreviewDesignsPDF: true,
        showDuplicateButton: true,
        showLayerButtons: true,
        showFlipButtons: true,
        showImageProvider: true,
        canUseTextArt: true,
        imageEditingToolSettingsToExclude: '[]',
        imageInsertScalingUpload: 0,
        imageInsertScalingCliparts: 0,
        useCustomFonts: null,
        convertEpsToSvg: true,
        convertPdfToSvg: true,
        convertAiToSvg: true,
        defaultFontFamilyID: null,
        fonts: [],
        curvedText: true,
        allowBold: true,
        allowItalic: true,
        uppercase: false,
        maxNrTextElements: null,
        maxNrImages: null,
        defaultColor: '#000000',
        allowLeftAlign: true,
        allowCenterAlign: true,
        allowJustifyAlign: true,
        allowRightAlign: true,
        textBox: true,
        allowLetterSpacing: true,
        minLetterSpacing: null,
        maxLetterSpacing: null,
        allowLineSpacing: true,
        minLineSpacing: null,
        maxLineSpacing: null,
        allowAdaptText: true,
        allowChangeFontSize: true,
        minFontSize: null,
        maxFontSize: null,
        fixedFontSize: null,
        allowTopVerticalAlignment: true,
        allowMiddleVerticalAlignment: true,
        allowBottomVerticalAlignment: true,
        allowShadows: true,
        canPrintShadows: true,
        disableImageRotateUpload: false,
        disableImageRotateCliparts: false,
        allowImageResizeUpload: null,
        minWidthImageResizeUpload: null,
        maxWidthImageResizeUpload: null,
        minHeightImageResizeUpload: null,
        maxHeightImageResizeUpload: null,
        allowImageResizeCliparts: null,
        minWidthImageResizeCliparts: null,
        maxWidthImageResizeCliparts: null,
        minHeightImageResizeCliparts: null,
        maxHeightImageResizeCliparts: null,
        defaultShadowColor: '#000000',
        shadowColors: [],
        defaultShadowBlur: null,
        defaultShadowDistance: null,
        defaultShadowAngle: null,
        minShadowBlur: null,
        maxShadowBlur: null,
        minShadowDistance: null,
        maxShadowDistance: null,
        minShadowAngle: null,
        maxShadowAngle: null,
        defaultFontSize: null,
        outputMirror: 0,
        embeddedColorType: 1,
        embeddedUseForRasterAlso: true,
        isLargeFileEnabled: true,
        fontSizeList: null,
        allowTextStroke: true,
        minTextStrokeWidth: 0,
        maxTextStrokeWidth: 4,
        canStretchImages: true,
        canStretchTexts: true,
        embeddedPdf: false
    },
    printTypeFonts: [],
    fonts: [],
    pantoneEnabled: false,
    previewDesignEffect: null,
    outputDesignEffect: null,
    maxColors: null,
    paletteID: null,
    paletteTypeID: null,
    paletteColors: [],
    splitColorFiles: false,
    layeredPdf: false,
    patternSettings: null,
    backgroundRemoverSettings: null
};

// Heat Transfer (HTV — heat-transfer vinyl): solid cut-vinyl colours heat-pressed onto the garment. A
// spot-colour method like Screenprinting — simple text/shapes, NO photos or gradients (each colour is a
// separate vinyl layer). So: a hardcoded palette of solid vinyl colours (rich picker + recolour via the
// sentinel-palette injection), NO raster uploads (vector cut paths only), no gradients / filters / shadows /
// effect, and splitColorFiles (one cut file per colour). Self-contained: no paletteID. Synthetic printTypeID.
export const HEAT_TRANSFER_PRINT_METHOD = {
    printTypeID: 1090918,
    name: 'Heat Transfer',
    providerCode: '',
    dpi: null,
    printTypeDPI: 300,
    priceDeltaPerc: 0,
    priceDeltaValue: 0,
    price: 0,
    textBasePrice: 0,
    imageBasePrice: 0,
    pricingID: 0,
    patID: 2,
    disableTextColors: null,
    disableImageColors: null,
    disableSellerImages: null,
    disableUserImages: null,
    useImagesFixedSize: null,
    textColors: null,
    imageColors: null,
    canAddText: null,
    canChangeSvgColors: null,
    canUseImageFilters: null,
    uploadRestrictions: null,
    canIgnoreDPIWarning: null,
    useCustomFonts: null,
    canPreviewDesignsPDF: null,
    showDuplicateButton: null,
    showLayerButtons: null,
    showFlipButtons: null,
    showImageProvider: null,
    canUseTextArt: null,
    imageEditingToolSettingsToExclude: null,
    convertEpsToSvg: null,
    convertPdfToSvg: null,
    convertAiToSvg: null,
    outputTypeID: null,
    printTypeDefaultFontFamilyID: null,
    defaultFontFamilyID: null,
    printTypeRestrictionsID: 1100881,
    outputSettings: null,
    printTypeRestrictions: {
        partPrintTypeRestrictionID: 1100881,
        disableTextColors: false,
        allowGradientTextColors: false,
        allowImageUploadTextColors: false,
        allowImageGalleryTextColors: false,
        enableVectorize: false,
        showVectorizeModal: false,
        vectorizeOption: 0,
        createVectorizePreview: false,
        disableImageColors: false,
        disableSellerImages: false,
        disableUserImages: false,
        useImagesFixedSize: false,
        textColors: [],
        imageColors: [],
        canAddText: true,
        canChangeSvgColors: true,
        canUseImageFilters: false,
        uploadRestrictions: {
            isUserImageAllowed: false,
            isJpgAllowed: false,
            isPngAllowed: false,
            isSvgAllowed: true,
            isPdfAllowed: true,
            isPdfWithRasterAllowed: false,
            isEpsAllowed: true,
            isAiAllowed: true,
            isFacebookAllowed: false,
            isInstagramAllowed: false,
            resizeLargePdf: false
        },
        canIgnoreDPIWarning: true,
        canPreviewDesignsPDF: true,
        showDuplicateButton: true,
        showLayerButtons: true,
        showFlipButtons: true,
        showImageProvider: true,
        canUseTextArt: true,
        imageEditingToolSettingsToExclude: '[]',
        imageInsertScalingUpload: 0,
        imageInsertScalingCliparts: 0,
        useCustomFonts: null,
        convertEpsToSvg: true,
        convertPdfToSvg: true,
        convertAiToSvg: true,
        defaultFontFamilyID: null,
        fonts: [],
        curvedText: true,
        allowBold: true,
        allowItalic: true,
        uppercase: false,
        maxNrTextElements: null,
        maxNrImages: null,
        defaultColor: '#000000',
        allowLeftAlign: true,
        allowCenterAlign: true,
        allowJustifyAlign: true,
        allowRightAlign: true,
        textBox: true,
        allowLetterSpacing: true,
        minLetterSpacing: null,
        maxLetterSpacing: null,
        allowLineSpacing: true,
        minLineSpacing: null,
        maxLineSpacing: null,
        allowAdaptText: true,
        allowChangeFontSize: true,
        minFontSize: null,
        maxFontSize: null,
        fixedFontSize: null,
        allowTopVerticalAlignment: true,
        allowMiddleVerticalAlignment: true,
        allowBottomVerticalAlignment: true,
        allowShadows: false,
        canPrintShadows: true,
        disableImageRotateUpload: false,
        disableImageRotateCliparts: false,
        allowImageResizeUpload: null,
        minWidthImageResizeUpload: null,
        maxWidthImageResizeUpload: null,
        minHeightImageResizeUpload: null,
        maxHeightImageResizeUpload: null,
        allowImageResizeCliparts: null,
        minWidthImageResizeCliparts: null,
        maxWidthImageResizeCliparts: null,
        minHeightImageResizeCliparts: null,
        maxHeightImageResizeCliparts: null,
        defaultShadowColor: '#000000',
        shadowColors: [],
        defaultShadowBlur: null,
        defaultShadowDistance: null,
        defaultShadowAngle: null,
        minShadowBlur: null,
        maxShadowBlur: null,
        minShadowDistance: null,
        maxShadowDistance: null,
        minShadowAngle: null,
        maxShadowAngle: null,
        defaultFontSize: null,
        outputMirror: 0,
        embeddedColorType: 2,
        embeddedUseForRasterAlso: true,
        isLargeFileEnabled: true,
        fontSizeList: null,
        allowTextStroke: true,
        minTextStrokeWidth: 0,
        maxTextStrokeWidth: 5,
        canStretchImages: false,
        canStretchTexts: false,
        embeddedPdf: false
    },
    printTypeFonts: [],
    fonts: [],
    pantoneEnabled: false,
    previewDesignEffect: null,
    outputDesignEffect: null,
    maxColors: 4,
    paletteID: null,
    paletteTypeID: null,
    paletteColors: ['#ffffff', '#000000', '#c8102e', '#003da5', '#00843d', '#ffd100', '#ff6900', '#5f259f', '#e93cac', '#a2aaad'],
    splitColorFiles: true,
    layeredPdf: false,
    patternSettings: null,
    backgroundRemoverSettings: null
};

/**
 * Maps a DiscoveryModePanel printing-method button id to the raw print-type payload streamed to the
 * customizer. Buttons without an entry here send `null` (no override) until they're implemented.
 */
export const DISCOVERY_PRINTING_PAYLOADS: Record<string, object> = {
    'dtg-printing': DTG_PRINT_METHOD,
    'wood-engraving': WOOD_ENGRAVING_PRINT_METHOD,
    pixelation: PIXELATION_PRINT_METHOD,
    'laser-engraving': ENGRAVING_PRINT_METHOD,
    screenprinting: SCREEN_PRINTING_PRINT_METHOD,
    monochromie: MONOCHROME_PRINT_METHOD,
    'pantone-colors': PANTONE_PRINT_METHOD,
    'cmyk-colors': CMYK_PRINT_METHOD,
    'uv-printing': UV_PRINT_METHOD,
    'heat-transfer': HEAT_TRANSFER_PRINT_METHOD
};
